// extracted by mini-css-extract-plugin
module.exports = {"noOptionsAvailable":"style__noOptionsAvailable___3c4Y8"};